(async () => {

  if (!customElements.get('hero-slider-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay, EffectFade } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay,
      EffectFade
    ]);

    class HeroSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-hero-slider]');
        this.swiperOptions = {};

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperElement.update();
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.handleSectionEvents(event);
          });
        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiperElement.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
      }
    }

    window.HeroSwiper = HeroSwiper;

    customElements.define('hero-slider-swiper', HeroSwiper);

  }

})();
